import { forwardRef, memo, useImperativeHandle, useRef, useState } from 'react';
import { NavBarSection } from '@apps/layouts/Navbar/styles';
import { ListItem } from '@mui/material';
import classNames from 'classnames';

import CarDetailHeaderNavBarItemProps, {
  CarDetailNavItemRefProps,
} from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CarDetailHeaderNavBarItemView: React.ForwardRefRenderFunction<
  CarDetailNavItemRefProps,
  CarDetailHeaderNavBarItemProps
> = (props, ref) => {
  const { handleClick, activeNavItems, containerStyle } = props;

  // ======================= HOOKS
  const navItemElementRef = useRef<HTMLUListElement | null>(null);
  const [focusedNavItem, setFocusedNavItem] = useState<string>('Highlight');

  // ======================= EFFECTS
  useImperativeHandle(
    ref,
    () => ({
      focusedNavItem,
      setFocusedNavItem,
      element: navItemElementRef.current,
    }),
    [focusedNavItem, setFocusedNavItem, navItemElementRef]
  );

  // ======================= VIEWS
  return (
    <NavBarSection
      ref={navItemElementRef}
      style={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'row',
        overflow: 'scroll',
        whiteSpace: 'nowrap',
        margin: '0 auto',
        maxWidth: 1240,
        scrollbarWidth: 'none',
        ...containerStyle,
        width: 'auto',
      }}
    >
      {activeNavItems?.map((navItem, index) => {
        const { key, title } = navItem;
        const isSelected = focusedNavItem === navItem.key;
        return (
          <ListItem
            key={`${index}`}
            id={`carDetailNavItem_${key}`}
            onClick={(event) => handleClick(event, key)}
            className={classNames('nav-item text-sm-unchanged ', {
              'nav-ani-tab-selected': isSelected,
              'nav-ani-tab': !isSelected,
            })}
            sx={{
              cursor: 'pointer',
              '&.MuiListItem-root': {
                width: 'auto',
              },
            }}
          >
            {title}
          </ListItem>
        );
      })}
    </NavBarSection>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export const CarDetailHeaderNavBarItem = memo(
  forwardRef(CarDetailHeaderNavBarItemView)
);
